import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./store/reducers/rootReducer";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { PostHogProvider, usePostHog } from "posthog-js/react";
import { getCurrentDomain } from "./utils/configLoader";
import { isConsoleHost } from "./console/isConsoleHost";
import ConsoleApp from "./console/ConsoleApp";

const initialState = {};
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;

// Registers tenant as a super property so every PostHog event includes it automatically.
function TenantRegistrar() {
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      posthog.register({ tenant: getCurrentDomain() });
    }
  }, [posthog]);

  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// risk-console.africacodefoundry.com is the ACA staff console: no tenant, no analytics
if (isConsoleHost()) {
  root.render(
    <React.StrictMode>
      <ConsoleApp />
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <PostHogProvider
          apiKey={process.env.REACT_APP_POSTHOG_KEY}
          options={{
            api_host: process.env.REACT_APP_POSTHOG_HOST,
            defaults: '2025-05-24',
            capture_exceptions: true,
            debug: process.env.NODE_ENV === "development",
          }}
        >
        <TenantRegistrar />
        <Provider store={store}>
          <App />
        </Provider>
      </PostHogProvider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();